import styled from 'styled-components';

import { CloseIcon } from '@atoms/Icons/CloseIcon';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { UploadIcon } from '@atoms/Icons/UploadIcon';
import { useState } from 'react';

export const LabelUploadCSV = styled('label')`
  display: flex;
  height: 206px;
  width: 852px;
`;

interface IUploadCSVPartProps {
  handleFileChange: (event: { target: { files: FileList; value: string } }) => Promise<void>;
  onCancel: () => void;
}

const UploadCSVPart: React.FC<IUploadCSVPartProps> = ({ handleFileChange, onCancel }) => {
  const [dragActive, setDragActive] = useState<boolean>(false);

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragActive(false);
  };

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragActive(false);

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const fileList = event.dataTransfer.files;
      const eventDataTemp = {
        target: {
          files: fileList,
          value: '',
        },
      };
      await handleFileChange(eventDataTemp);
    }
  };

  return (
    <Box py="24px" px="32px" height="100%" width="100%">
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h5"></Typography>
        <IconButton
          onClick={onCancel}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '20px',
            color: '#464F60',
            whiteSpace: 'normal',
            marginBottom: '18px',
          }}
        >
          Upload CSV
        </Typography>
      </Box>
      <Divider />
      <Box display={'flex'} alignItems="center" marginTop="10px">
        <Typography
          sx={{
            fontSize: '14px',
            lineHeight: '20px',
            color: '#000000',
            whiteSpace: 'normal',
          }}
        >
          DATA
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            lineHeight: '20px',
            color: '#A1A9B8',
            whiteSpace: 'normal',
          }}
        >
          (.csv)
        </Typography>
      </Box>

      <LabelUploadCSV htmlFor="file-upload" style={{ cursor: 'pointer' }}>
        <Box
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          sx={{
            border: '2px dashed #ccc',
            borderRadius: '10px',
            padding: '20px',
            textAlign: 'center',
            cursor: 'pointer',
            width: '852px',
            height: '206px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: dragActive ? '#f0f0f0' : '#F2F4F7',
            margin: '22px 0',
          }}
        >
          <Box
            sx={{
              width: '151px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <UploadIcon />
            <Typography
              sx={{
                fontSize: '10px',
                lineHeight: '20px',
                color: '#A1A9B8',
                whiteSpace: 'normal',
              }}
            >
              Select a CSV file to upload or drag and drop it here
            </Typography>
          </Box>
        </Box>
      </LabelUploadCSV>
      <Divider />
    </Box>
  );
};

export default UploadCSVPart;
